import { FormProvider as e } from "../node_modules/react-hook-form/dist/index.esm.js";
import { jsx as o } from "../_virtual/jsx-runtime.js";
function d({
  children: m,
  formConfig: r,
  onSubmit: t,
  className: i
}) {
  return /* @__PURE__ */ o(e, {
    ...r,
    children: /* @__PURE__ */ o("form", {
      onSubmit: r.handleSubmit(t),
      className: i,
      children: m
    })
  });
}
export {
  d as Form
};
//# sourceMappingURL=Form.js.map
